<template>
    <v-popover class="popover"
               trigger="manual"
               :placement="placement"
               popoverInnerClass="tooltip-inner"
               popoverBaseClass="vueTooltip"
               popoverArrowClass="tooltip-arrow"
               :autoHide="false"
               :ref="uniqueId">
        <slot>
            <IconBase
                    width="10"
                    height="10"
                    :icon-color="consts.COLORS.LIGHT_700"
                    icon-name="infoTooltipIcon"/>
        </slot>
        <template slot="popover">
            <div class="disclaimer">
                <div class="disclaimer-text">
                    {{ title }}
                </div>
                <div class="disclaimer-text">
                    {{ text }}
                </div>
                <div class="disclaimer-button">
                    <button @click="acknowledgeDisclaimer"
                            class="primary small">
                        Got it!
                    </button>
                </div>
            </div>
        </template>
    </v-popover>
</template>

<script>
import Vue from 'vue';
import tooltip from 'services/libWrappers/vue-tooltip';
import IconBase from 'components/IconBase.vue';
import consts from 'services/metaData/consts';

tooltip(Vue);
const localStorageKey = 'seenDisclaimers';

export default {
    name: 'Disclaimer',
    components: {
        IconBase
    },
    props: {
        text: String,
        title: String,
        uniqueId: String,
        placement: {
            type: String,
            default: 'right'
        }
    },
    data() {
        return {
            consts
        };
    },
    methods: {
        acknowledgeDisclaimer() {
            if (!this.uniqueId) return;

            let seenDisclaimers = [];
            const localStorageValue = localStorage.getItem(localStorageKey);
            if (localStorageValue) {
                seenDisclaimers = JSON.parse(localStorageValue);
            }
            if (!seenDisclaimers.includes(this.uniqueId)) {
                seenDisclaimers.push(this.uniqueId);
            }

            // save in local storage
            localStorage.setItem(localStorageKey, JSON.stringify(seenDisclaimers));
            this.$refs[this.uniqueId].hide();
        }
    },
    mounted() {
        const seenDisclaimers = JSON.parse(localStorage.getItem(localStorageKey));
        if (!seenDisclaimers || !seenDisclaimers.includes(this.uniqueId)) {
            this.$refs[this.uniqueId].show();
        }
    }
};
</script>

<style scoped lang="scss">
    @import "~styles/buttons";

    .disclaimer {
        max-width: 210px;
        display: grid;
        grid-template-columns: auto 70px;
    }

    .disclaimer-text {
        grid-column-start: 1;
        grid-column-end: 3;
    }

    .disclaimer-button {
        grid-column-start: 2;
        margin-top: 10px;
    }
</style>
